import {defineStore} from 'pinia';
import {useModal} from "~/stores/ModalStore.js";
import Alert from "~/components/Alert.vue";

export const useAlertStore = defineStore('alert', () => {

    function success(title, message) {
        useModal().openModal('AlertModal', Alert, {
            type: 'success',
            title,
            message
        });
    }

    function saved(message) {
        success('Saved', message);
    }

    function error(title, message) {
        useModal().openModal('AlertModal', Alert, {
            type: 'danger',
            title,
            message
        });
    }

    function warning(message, callback, deleteButtonText, cancelButton) {
        useModal().openModal('AlertModal', Alert, {
            type: 'warning',
            message,
            callback,
            deleteButtonText,
            cancelButton
        })
    }

    return {
        success,
        saved,
        warning,
        error
    };
});
